'use client'
import { getUserInitials } from '@/helpers/content'

import { useAuthenticatedData } from '@/hooks/useAuthenticatedData'
import type { ApiResponse } from '@/hooks/useAuthenticatedData'
import useIsMobile from '@/hooks/useIsMobile'

import type { ButtonBaseProps } from '@/components/atoms/Button/Button.types'
import { ButtonLabel } from '@/components/atoms/Typography'
import DropDown from '@/components/atoms/Dropdown'
import MenuLoggedModel from '@/models/MenuLogged'

import styles from './HeaderMenuLogged.module.scss'

const LoggedMenuUl = () => {
  const loggedMenu = MenuLoggedModel()

  return loggedMenu.map((link) => (
    <li key={link.label}>
      <a
        className={styles.loggedMenuLink}
        translate='no'
        {...link}
      >
        <ButtonLabel>{link.label}</ButtonLabel>
      </a>
    </li>
  ))
}

const HeaderMenuLogged = () => {
  const { apiResponse, loading } = useAuthenticatedData('me')
  const isMobile = useIsMobile()

  const userLogged = !!apiResponse && !loading

  if (!userLogged || loading) return <></>
  const { first_name, last_name } = apiResponse as ApiResponse & {
    first_name: string
    last_name: string
  }

  return userLogged && !!isMobile ? (
    <ul className={styles.loggedMenuUl}>
      <LoggedMenuUl />
    </ul>
  ) : (
    <DropDown
      className={styles.loggedMenu}
      trigger={getUserInitials({
        first_name,
        last_name,
      })}
      triggerProps={
        {
          variant: 'primary',
          theme: 'dark',
          autoWidth: true,
          translate: 'no',
          className: styles.loggedMenuTrigger,
        } as ButtonBaseProps
      }
    >
      <LoggedMenuUl />
    </DropDown>
  )
}

export default HeaderMenuLogged
